export const DEFAULT_NEW_CHAPTER_TITLE = 'New chapter';
